'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("scopeUtils", function ($parse) {
  var scopeUtils = {
    dataBind: function dataBind(parentScopeName, scopeName, childScope, parentScope) {
      if (parentScope == null) {
        parentScope = childScope.$parent;
      }
      var parentGet = $parse(parentScopeName);
      var compare = parentGet.literal ? angular.equals : function (a, b) {
        return a === b;
      };
      var lastValue;
      var parentSet = parentGet.assign || function () {
        // reset the change, or we will throw this exception on every $digest
        lastValue = childScope[scopeName] = parentGet(parentScope);
        throw "didnt understand this exception";
      };
      lastValue = childScope[scopeName] = parentGet(parentScope);
      return childScope.$watch(function parentValueWatch() {
        var parentValue = parentGet(parentScope);
        if (!compare(parentValue, childScope[scopeName])) {
          // we are out of sync and need to copy
          if (!compare(parentValue, lastValue)) {
            // parent changed and it has precedence
            childScope[scopeName] = parentValue;
          } else {
            // if the parent can be assigned then do so
            parentSet(parentScope, parentValue = childScope[scopeName]);
          }
        }
        return lastValue = parentValue;
      }, null, parentGet.literal);
    },
    /**
     * Creates an accessor method to get or set given property on given scope.
     *
     * @param {Scope} scope : Scope to create accessor for
     * @param {String} propertyName : Name of the property to create accessor of.
     */
    createAccessor: function createAccessor(scope, propertyName) {
      var getter = $parse(propertyName);
      var setter = getter.assign;
      return function (value) {
        if (arguments.length) {
          return setter(scope, value);
        } else {
          return getter(scope);
        }
      };
    },
    /**
     * Count the watchers attached to a scope tree.
     *
     * @param scope The scope to count watchers of.
     * @returns {number} The number of watchers actually attach to given scope and children.
     */
    countWatchers: function countWatchers(scope) {
      var watchers = 0;
      scopeUtils.traverseScopeTree(scope, function (scope) {
        if (scope.$$watchers) {
          watchers += scope.$$watchers.length;
        }
      });
      return watchers;
    },
    /**
     * Apply watchers of given scope even if a digest progress is already in process on another level.
     * This will only do a one-time cycle of watchers, without cascade digest.
     *
     * Please note that this is (almost) a hack, behaviour may be hazardous so please use with caution.
     *
     * @param {Scope} scope : scope to apply watchers from.
     */
    applyWatchers: function applyWatchers(scope) {
      scopeUtils.traverseScopeTree(scope, function (scope) {
        var watchers = scope.$$watchers;
        if (!watchers) {
          return;
        }
        var watcher;
        for (var i = 0; i < watchers.length; i++) {
          watcher = watchers[i];
          var value = watcher.get(scope);
          watcher.fn(value, value, scope);
        }
      });
    },
    traverseScopeTree: function traverseScopeTree(parentScope, traverseFn) {
      var next,
        current = parentScope,
        target = parentScope;
      do {
        traverseFn(current);
        if (!(next = current.$$childHead || current !== target && current.$$nextSibling)) {
          while (current !== target && !(next = current.$$nextSibling)) {
            current = current.$parent;
          }
        }
      } while (current = next);
    }
  };
  return scopeUtils;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/scopeUtils.js
// module id = 2763
// module chunks = 13